import Api from "../../../util/Api";

export default function getInitState() {
    return {
        roleFormIsOpen: false,
        roleGridIsOpen: true,

        roleActions: [
            {
                btn_text: '<i class="fas fa-user-cog"></i> Engedélyek kezelése',
                event_name: "customClick",
                class: "btn btn-info my-custom-class",
                event_payload: 'newPermission'
            },
            {
                btn_text: '<i class="fas fa-plus"></i> Új jogosultság',
                event_name: "customClick",
                class: "btn btn-success my-custom-class",
                event_payload: 'newRoleRow'
            }
        ],
        roleFormActions: [
            {
                btn_text: '<i class="fa fa-backward"></i> Vissza',
                event_name: "customClick",
                class: "btn btn-warning my-custom-class mx-1",
                event_payload: 'backToRoleGrid'
            }, {
                btn_text: '<i class="fas fa-trash"></i> Reset',
                event_name: "customClick",
                class: "btn btn-secondary my-custom-class mx-1",
                event_payload: 'resetRoleForm'
            }
        ],
        roleRowActions: [
            {
                btn_text: '<i class="fas fa-edit"></i>',
                title: 'Szerkesztés',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'modifyRoleRow'
            }, {
                btn_text: '<i class="fas fa-trash"></i>',
                title: 'Törlés',
                event_name: "customClick",
                class: "btn btn-outline-danger",
                event_payload: 'deleteRoleRow'
            }
        ],
        roleHeaderFields: [
            {
                name: "id",
                label: "Azonosító",
                visibility: false,
                formVisible: false
            },
            {
                name: "role",
                label: "Jogosultság neve",
                filter: {
                    type: "simple",
                },
                sort: true,
                visibility: true,
                formType: 'text',
                formSize: 6,
                formVisible: true,
                formRequired: true
            },
            {
                name: "permissions",
                label: "Engedélyek",
                visibility: false,
                formType: 'checkboxes',
                checkboxesOptions: {
                    apiCallback: Api.getAllPermission,
                    formatOption: function (val) {
                        return val.name;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'name',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 6,
                formVisible: true,
                formRequired: true
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            }
        ],

        permissionFormIsOpen: false,
        permissionGridIsOpen: false,
        permissionActions: [
            {
                btn_text: '<i class="fa fa-backward"></i> Vissza',
                event_name: "customClick",
                class: "btn btn-warning my-custom-class",
                event_payload: 'backToRoleGrid'
            },
            {
                btn_text: '<i class="fas fa-plus"></i> Új engedély',
                event_name: "customClick",
                class: "btn btn-success my-custom-class",
                event_payload: 'newPermissionRow'
            }
        ],
        permissionFormActions: [
            {
                btn_text: '<i class="fa fa-backward"></i> Vissza',
                event_name: "customClick",
                class: "btn btn-warning my-custom-class mx-1",
                event_payload: 'backToPermissionGrid'
            }, {
                btn_text: '<i class="fas fa-trash"></i> Reset',
                event_name: "customClick",
                class: "btn btn-secondary my-custom-class mx-1",
                event_payload: 'resetPermissionForm'
            }
        ],
        permissionRowActions: [
            {
                btn_text: '<i class="fas fa-edit"></i>',
                title: 'Szerkesztés',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'modifyPermissionRow'
            }, {
                btn_text: '<i class="fas fa-trash"></i>',
                title: 'Törlés',
                event_name: "customClick",
                class: "btn btn-outline-danger",
                event_payload: 'deletePermissionRow'
            }
        ],
        permissionHeaderFields: [
            {
                name: "id",
                label: "Azonosító",
                visibility: false,
                formVisible: false
            },
            {
                name: "name",
                label: "Engedély neve",
                filter: {
                    type: "simple",
                },
                sort: true,
                visibility: true,
                formType: 'text',
                formSize: 12,
                formVisible: true,
                formRequired: true
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            }
        ]
    }
}
